module.exports = __webpack_public_path__ + "static/media/ReactJS_icon.5c0ca311.png";